import { ConverterRegistry } from '../../core/converter';
import { AiOcrConverter, type AiOcrDeps } from './ocr-converter';

export type { AiOcrDeps };

/**
 * AI 引擎注册表。
 *
 * 必须排在本地引擎**之后**注册：`resolve()` 按注册顺序取第一个可用引擎，
 * 这样 pdf→txt 默认走本地文本层提取，只有用户显式选择 AI 通道时才会用到这里。
 */
export function registerAiEngines(registry: ConverterRegistry, deps: AiOcrDeps = {}): ConverterRegistry {
  registry.register(new AiOcrConverter(deps));
  return registry;
}

export function createAiRegistry(deps: AiOcrDeps = {}): ConverterRegistry {
  return registerAiEngines(new ConverterRegistry(), deps);
}
